<template>
  <div>
    <h2 class="payTitle notranslate">{{locale.order_information}}</h2>
    <SummaryItem v-for="(item, index) in summaryList"
      :key="index"
      :locale="locale"
      :localeAmenity="localeAmenity"
      :lang="lang"
      :item="item" />
  </div>
</template>

<script>
import SummaryItem from '@/components/Payment/SummaryItem.vue'

export default {
  name: 'Summary',
  props: [
    'lang',
    'locale',
    'summary'
  ],
  components: {
    SummaryItem
  },
  computed: {
    localeAmenity () {
      return this.$store.state.system.localeAmenity.data
    },
    summaryList () {
      return this.summary.filter(x => x.price && x.price.info.total > 0 && x.submitId !== 'tip')
    }
  }
}
</script>
